import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "Pohde_email_token";

export const getJwtToken = () => localStorage.getItem(TOKEN_KEY);
export const setJwtToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const removeJwtToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isTokenExpired = () => {
  const token = getJwtToken();
  if (!token) {
    return true;
  }
  try {
    const decoded = jwtDecode(token);
    if (!decoded.exp) return true;
    const now = Date.now() / 1000;
    return decoded.exp < now;
  } catch (e) {
    console.error("Failed to decode token", e);
    return true;
  }
};

export const emailAuth = {
  getJwtToken,
  setJwtToken,
  removeJwtToken,
  isTokenExpired,
};
